module.exports = __webpack_public_path__ + "static/media/footage_selected.4f7fb098.svg";